import { Dialog } from "primereact/dialog";
import React from "react";
import { Button } from "primereact/button";
import "./LatestInputsOutputs.scss";
import { DataType } from "./LatestInputsOutputs";

interface InputsOutputsHistoryProps {
  dataType: DataType;
  dataHistory: any[];
  isDataHistoryDialogVisible: boolean;
  setIsDataHistoryDialogVisible: React.Dispatch<React.SetStateAction<boolean>>;
  refetchHistory: () => void;
  copyToClipboard: () => void;
}

const InputsOutputsHistory = (props: InputsOutputsHistoryProps) => {
  const dialogHeaderTemplate = () => {
    return (
      <div className="flex justify-content-start align-items-center gap-3">
        <span>
          {`${
            props.dataType === DataType.INPUT ? "Inputs" : "Outputs"
          } history`}
        </span>
        <Button
          icon="pi pi-refresh"
          className="p-button-text ml-2 custom-button"
          tooltip="Refresh history"
          tooltipOptions={{ position: "bottom" }}
          onClick={props.refetchHistory}
        />
        <Button
          icon="pi pi-clone"
          className="p-button-text ml-2 custom-button"
          tooltip="Copy history"
          tooltipOptions={{ position: "bottom" }}
          onClick={props.copyToClipboard}
        />
      </div>
    );
  };

  return (
    <Dialog
      header={dialogHeaderTemplate}
      visible={props.isDataHistoryDialogVisible}
      style={{
        width: "30%",
        height: "100%",
        position: "absolute",
        bottom: "0px",
        right: "0px",
      }}
      modal={false}
      resizable
      onHide={() => props.setIsDataHistoryDialogVisible(false)}
    >
      <div>
        <pre>{JSON.stringify(props.dataHistory, null, 2)}</pre>
      </div>
    </Dialog>
  );
};

export default InputsOutputsHistory;
